import Vuelidate from 'vuelidate';
import Vue from 'vue';

export default () => {
  Vue.use(Vuelidate);
};
